import { render, staticRenderFns } from "./ApplicationUnderFOAEAA.vue?vue&type=template&id=052be816"
import script from "./ApplicationUnderFOAEAA.vue?vue&type=script&lang=ts"
export * from "./ApplicationUnderFOAEAA.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports